//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {twoColumn} from 'components';
export default {
  name: 'waterFalls',
  type: 'component',
  options: {
    addGlobalClass: true,
  },
  props: {
    /**
     * 数组
     **/
    items: {
      type: Array
    },
    /**
     * 分栏数目
     **/
    column: {
      type: Number,
      default: 2
    },
    floorAttribute:{
      type:Number
    },
    isGroupGoods:{
      type:Boolean,
      default:false
    },
    imageStyle: {
      type: String,
      default: "width: 370px; height: 370px;"
    },
    params:{
      type:Object
    }
  },
  data() {
    return {
    }
  },
  computed: {
    splitData() {
      const {items, column} = this;
      const arr = [];
      for (let i=0; i < column; i++) {
        arr[i] = items.filter((item, index) => {
          if (index % 2 === i) {
            return item;
          }
        })
      }
      return arr;
    }
  },
  components: {twoColumn},
  methods: {
    handleClick(v,params){
      this.$emit("click",v ,params);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/waterFalls.vue